import styled from '@emotion/styled';
import { ResetButton } from '~/shared/components/Button/ResetButton';

type StyledIconButtonProps = {
    active?: boolean;
    mobileOnly?: boolean;
    small?: boolean;
    full?: boolean;
    desktop?: boolean;
    textColor?: string;
};
export const StyledBackButton = styled(ResetButton)<StyledIconButtonProps>(({ theme }) => ({
    display: 'flex',
    padding: `0 0 0 ${theme.space[1]}}`,
    alignItems: 'center',
    justifyContent: 'flex-start',
    alignContent: 'center',
    svg: {
        height: '16px',
        width: '16px',
        margin: `0 ${theme.space[2]} 0 ${theme.space[2]}`,
    },
}));
export const Title = styled.div(({ theme }) => ({
    display: 'flex',
    marginBottom: theme.space[1],
    flexDirection: 'row',

    svg: {
        padding: 0,
        marginLeft: 0,
    },
}));

export const DeliveryButton = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    padding: `0 0 0 ${theme.space[3]}}`,
}));
